import { render, staticRenderFns } from "./neonClockDesign.vue?vue&type=template&id=66892bba&scoped=true"
import script from "./neonClockDesign.vue?vue&type=script&lang=js"
export * from "./neonClockDesign.vue?vue&type=script&lang=js"
import style0 from "./neonClockDesign.vue?vue&type=style&index=0&id=66892bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66892bba",
  null
  
)

export default component.exports